<template>
  <div class="user_body">
    <span class="title">收货地址</span>
    <div class="add_list">
      <div class="add_item" @click="openAddressDialog()">
        <img src="@/assets/icon_add.png" class="add_item_img">
        <span class="add_text">添加新地址</span>
      </div>
      <div
        :class="item.is_default == 1?'add_item2':'add_item3'"
        v-for="(item,index) in addressList"
        :key="index"
        @click="setDefaultAddress(index,item)"
      >
        <div class="address-header">
          <span class="title2">{{ item.consignee }}</span>
         
        </div>
        <span class="text1">{{ item.phone }}</span>
        <span class="text1">{{item.province_name }}{{ item.city_name }}{{ item.area_name }}{{ item.address }}</span>
        <div class="address-action">
            <span class="edit-btn" @click.stop="editAddress(item)">编辑</span>
            <span class="delete-btn" @click.stop="confirmDeleteAddress(item.id)">删除</span>
          </div>
      </div>
    </div>

    <el-dialog :title="isEdit ? '编辑收货地址' : '添加收货地址'" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form :model="addressForm" :rules="rules" ref="addressForm" label-width="0px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="consignee">
              <el-input v-model="addressForm.consignee" autocomplete="off" placeholder="姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="phone">
              <el-input v-model="addressForm.phone" autocomplete="off" placeholder="手机号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top:10px;">
          <el-col :span="24">
            <el-form-item prop="region">
              <el-cascader
                v-model="addressForm.region"
                :options="regionOptions"
                @change="handleRegionChange"
                placeholder="选择省 / 市 / 区 / 街道"
                style="width: 100%"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top:10px;">
          <el-col :span="24">
            <el-form-item prop="address">
              <el-input v-model="addressForm.address" autocomplete="off" placeholder="详细地址" type="textarea" :rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top:10px;">
          <el-col :span="24">
            <el-checkbox v-model="addressForm.is_default" :true-label="1" :false-label="0">设为默认地址</el-checkbox>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <span @click="submitAddress" class="btn1">确定</span>
        <span @click="dialogVisible = false" class="btn2">取消</span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentIndex: -1,
      addressList: [],
      dialogVisible: false,
      isEdit: false,
      addressForm: {
        id: '',
        consignee: '',
        phone: '',
        region: [],
        address: '',
        is_default: 0
      },
      rules: {
        consignee: [
          { required: true, message: '请输入收货人姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择所在地区', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ]
      },
      regionOptions: [],
    };
  },
  mounted() {
    this.getAddressList();
    this.getRegions();
  },
  methods: {
    // 获取地址列表
    async getAddressList() {
      try {
        const res = await this.$api.getAddressList();
        if (res.code === 1) {
          this.addressList = res.data;
          // 如果有默认地址，设置选中
          const defaultIndex = this.addressList.findIndex(item => item.is_default === 1);
          if (defaultIndex !== -1) {
            this.currentIndex = defaultIndex;
          }
        } else {
          this.$message.error(res.message || '获取地址列表失败');
        }
      } catch (err) {
        this.$message.error(err.message || '获取地址列表失败');
      }
    },
    
    // 获取地区数据
    async getRegions() {
      try {
        const res = await this.$api.getRegions();
        if (res.code === 1) {
          this.regionOptions = this.formatRegionOptions(res.data);
        } else {
          this.$message.error(res.message || '获取地区数据失败');
        }
      } catch (err) {
        this.$message.error(err.message || '获取地区数据失败');
      }
    },
    
    // 格式化地区数据为级联选择器格式
    formatRegionOptions(regions) {
      const formatData = (data, level = 0) => {
        return data.map((item,index) => {
          const result = {
            value: item.name,
            label: item.name
          };
          
          if (item.children && item.children.length) {
            result.children = formatData(item.children, level + 1);
          }
          
          return result;
        });
      };
      
      return formatData(regions);
    },
    
    // 处理地区变化
    handleRegionChange(value) {
      console.log('value is',value)
      console.log('this.form.region is',this.addressForm.region)
      // this.addressForm.region = value
    },
    
    // 打开添加地址对话框
    openAddressDialog() {
      this.isEdit = false;
      this.resetForm();
      this.dialogVisible = true;
    },
    
    // 编辑地址
    async editAddress(address) {
      this.isEdit = true;
      this.addressForm = {
        ...address,
        region:[address.province_name,address.city_name,address.area_name,address.street_name]
      };
      
      // 通过地区名称查找对应的地区ID
      const regionNames = address.region;
      // 实际项目中可能需要根据ID获取地区，这里简化处理
      
      this.dialogVisible = true;
    },
    
    // 确认删除地址
    confirmDeleteAddress(id) {
      this.$confirm('确定要删除该地址吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteAddress(id);
      }).catch(() => {
        // 取消删除操作
      });
    },
    
    // 删除地址
    async deleteAddress(id) {
      try {
        const res = await this.$api.delAddress({ id });
        if (res.code === 1) {
          this.$message.success('删除地址成功');
          // 刷新地址列表
          this.getAddressList();
        } else {
          this.$message.error(res.message || '删除地址失败');
        }
      } catch (err) {
        this.$message.error(err.message || '删除地址失败');
      }
    },
    
    // 提交地址表单
    submitAddress() {
      this.$refs.addressForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        
        try {
          const res = await this.$api.editAddress(this.addressForm);
          if (res.code === 1) {
            this.$message.success(this.isEdit ? '编辑地址成功' : '添加地址成功');
            this.dialogVisible = false;
            // 刷新地址列表
            this.getAddressList();
          } else {
            this.$message.error(res.message || (this.isEdit ? '编辑地址失败' : '添加地址失败'));
          }
        } catch (err) {
          this.$message.error(err.message || (this.isEdit ? '编辑地址失败' : '添加地址失败'));
        }
      });
    },
    
    // 重置表单
    resetForm() {
      this.addressForm = {
        id: '',
        consignee: '',
        phone: '',
        region: [],
        address: '',
        is_default: 0
      };

      
      if (this.$refs.addressForm) {
        this.$refs.addressForm.resetFields();
      }
    },
    
    // 关闭对话框
    handleClose(done) {
      this.$confirm("确认关闭？未保存的内容将会丢失")
        .then(_ => {
          this.resetForm();
          done();
        })
        .catch(_ => {});
    },
    
    // 选择地址
    async setDefaultAddress(index,item){
      this.addressForm = {...item};
      this.addressForm.is_default = 1;
      this.addressForm.region = [item.province_name,item.city_name,item.area_name,item.street_name];
      try {
          const res = await this.$api.editAddress(this.addressForm);
          if (res.code === 1) {
            this.$message.success('设置默认地址成功');
  
            // 刷新地址列表
            this.getAddressList();
          } else {
            this.$message.error(res.message || '设置默认地址失败');
          }
        } catch (err) {
          this.$message.error(err.message || '设置默认地址失败');
        }

    
          
    }
  }
};
</script>
<style lang="less" scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
}
.title {
  color: #666666;
  font-size: 16px;
}
.add_list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 20px;
  gap: 10px;
}
.add_item {
  width: calc(100% / 3 - 10px);
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  cursor: pointer;
}
.add_item2 {
  width: calc(100% / 3 - 10px);
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-image: url("@/assets/bg_address_select.png");
  background-size: 100% 100%;
  padding: 20px 10px 0px 20px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
}
.add_item3 {
  width: calc(100% / 3 - 10px);
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-size: cover;
  padding: 20px 10px 0px 20px;
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
  position: relative;
  cursor: pointer;
}
.add_item_img {
  width: 30px;
  height: 30px;
  margin-bottom: 10px;
}
.add_text {
  color: #e0e0e0;
  font-size: 14px;
  font-weight: 800;
}
.address-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.address-action {
  display: flex;
  gap: 10px;
}
.edit-btn, .delete-btn {
  color: #3C9C8F;
  font-size: 12px;
  cursor: pointer;
}
.delete-btn {
  color: #F56C6C;
}
.title2 {
  color: #333333;
  font-size: 16px;
}
.text1 {
  color: #333333;
  font-size: 14px;
  margin-bottom: 5px;
  color: #999999;
}
.default-tag {
  position: absolute;
  right: 0;
  bottom: 0;
  background: #3C9C8F;
  color: white;
  padding: 2px 8px;
  font-size: 12px;
}
.dialog-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #F5F5F5;
  padding: 0px;
  padding-top: 30px;
  padding-bottom: 30px;
}
.btn1{
    background: #3C9C8F;
    color: white;
    width: 140px;
    height: 40px;
    text-align: center; 
    line-height: 40px;
    margin-right: 30px;
    border-radius: 5px;
    cursor: pointer;
}
.btn2{
    background: white;
    color: #999999;
    width: 140px;
    height: 38px;
    text-align: center; 
    line-height: 40px;
    border: 1px solid #999999;
    border-radius: 5px;
    cursor: pointer;
}

</style>
<style>
.el-dialog__footer{ 
    padding: 0 !important;
    text-align: right;
    box-sizing: border-box;
    background: RGBA(245, 245, 245, 1) !important; 
}</style>